import axios from 'axios';

// Logout handler - will be set by AuthContext
let logoutHandler = null;

export const setLogoutHandler = (handler) => {
  logoutHandler = handler;
};

// Setup global axios interceptor for 401 handling
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const requestUrl = error.config?.url || "";
      const requestMethod = error.config?.method?.toLowerCase() || "";

      // Guest Portal session lives in its own (OTP-only) auth space — it does
      // NOT share the regular client account flow. A 401 from /guest-portal/*
      // means the 30-min portal JWT expired and the guest should be returned
      // to the portal's OTP screen, not the account login page.
      const isPortalEndpoint = requestUrl.includes("/guest-portal/");
      // OTP request/verify themselves don't carry auth — skip the redirect for
      // those (they 401 on bad OTP, not on session expiration).
      const isPortalAuthEndpoint =
        requestUrl.includes("/guest-portal/request-otp") ||
        requestUrl.includes("/guest-portal/verify-otp");

      if (isPortalEndpoint && !isPortalAuthEndpoint) {
        localStorage.removeItem("tali_guest_portal_token");
        localStorage.removeItem("tali_guest_portal_email");
        if (window.location.pathname !== "/portal") {
          window.location.href = "/portal?session=expired";
        }
        return Promise.reject(error);
      }

      // List of public endpoints that don't require authentication
      // These should NOT trigger session expiration redirect
      const isPublicEndpoint =
        requestUrl.includes("/auth/login") ||
        requestUrl.includes("/auth/register") ||
        requestUrl.includes("/auth/forgot-password") ||
        requestUrl.includes("/auth/verify") ||
        requestUrl.includes("/auth/resend") ||
        requestUrl.includes("/auth/reset-password") ||
        // Public restaurant endpoints
        requestUrl.includes("/restaurants") ||
        // Public reservation endpoint (POST /reservations without /user)
        (requestMethod === "post" && requestUrl.match(/\/reservations\/?$/) && !requestUrl.includes("/user")) ||
        // Public availability check
        requestUrl.includes("/availability") ||
        // Public shifts
        requestUrl.includes("/shifts") ||
        // Public zones
        requestUrl.includes("/zones") ||
        // Widget endpoint
        requestUrl.includes("/widget");

      if (!isPublicEndpoint) {
        // Clear auth data from localStorage
        localStorage.removeItem("tali_client_token");
        localStorage.removeItem("tali_client_isLoggedIn");
        localStorage.removeItem("tali_client_userPayload");

        // Call the logout handler if set (updates React state)
        if (logoutHandler) {
          logoutHandler();
        }

        // Redirect to login page with session expired message
        if (window.location.pathname !== "/login") {
          window.location.href = "/login?session=expired";
        }
      }
    }
    return Promise.reject(error);
  }
);
